import { debounce } from 'lodash-es';
import { useRef, useState, type MouseEvent as ReactMouseEvent } from 'react';

import { isMouseOutsideElement } from '../../../utils/is-mouse-outside-element.js';

const DEBOUNCE_TIME_MS = 5;

/**
 * @internal
 */
export function useChartActionsMenu() {
  const [selectedItem, setSelectedItem] = useState<string>('');
  const [isScrolling, setIsScrolling] = useState(false);
  const actionsMenuRef = useRef<HTMLDivElement>(null);

  const onLeave = (event?: ReactMouseEvent) => {
    if (!event || isMouseOutsideElement(event, actionsMenuRef)) {
      setSelectedItem('');
    }
  };

  const onScrollEnd = debounce(() => setIsScrolling(false), DEBOUNCE_TIME_MS);

  const onScroll = (event?: Event) => {
    setSelectedItem('');
    setIsScrolling(true);
    onScrollEnd();
  };

  const onUpdateSelectedItem = (itemId: string) => {
    if (selectedItem !== itemId) {
      setSelectedItem(itemId);
    }
  };

  return {
    selectedItem,
    isScrolling,
    onLeave,
    onScroll,
    updateSelectedItem: onUpdateSelectedItem,
    actionsMenuRef,
  };
}
